import { useMatomo } from "@jonkoops/matomo-tracker-react";
import Button from "../../components/Button";
import Stars from './../../img/stars.svg';

function Testimonials() {
    const { trackEvent } = useMatomo(); 
    const testimonials: testimonialObject[] = [
        {
            name: "Andre",
            quote: "3Folio offers me an overview I have been dreaming for a long time",
            link: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
            avatarUrl: "https://images.unsplash.com/flagged/photo-1553642618-de0381320ff3?crop=entropy&cs=tinysrgb&fit=crop&fm=jpg&h=100&ixid=MnwxfDB8MXxyYW5kb218MHx8dGF4aXx8fHx8fDE2NzMxMDEzMjI&ixlib=rb-4.0.3&q=80&utm_campaign=api-credit&utm_medium=referral&utm_source=unsplash_source&w=100",
            position: "is a co-founder of Becao."
        },
        {
            name: "Anne",
            quote: "Great crypto fund manager. Great support.",
            link: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
            // get unsplash image with 75x75px
            avatarUrl: "https://images.unsplash.com/photo-1481214110143-ed630356e1bb?crop=entropy&cs=tinysrgb&fit=crop&fm=jpg&h=100&ixid=MnwxfDB8MXxyYW5kb218MHx8dGF4aXx8fHx8fDE2NzMxMDEzMjI&ixlib=rb-4.0.3&q=80&utm_campaign=api-credit&utm_medium=referral&utm_source=unsplash_source&w=100",
            position: "works as an operative at one of the largest banks in Europe."
        },
        {
            name: "Anton",
            quote: "Perfect product with excellent technical implementation.",
            link: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
            avatarUrl: "https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50",
            position: "is Director of Technology at BitBank GmbH."
        },
    ];

    const testimonialsCSSPositions = ["lg:-ml-20 lg:self-start", "lg:-mr-20 lg:self-end", "lg:-ml-20 mb-5 lg:self-start"]

    const onTestimonialClicked = (link: string, name: string) => {
        trackEvent({ category: 'testimonials', action: `${name} testimonial clicked` });
        window.open(link, "_blank");
    }

    return(
        <div className="mb-16 max-lg:p-5">
            <h1 className="text-4xl font-bold text-slate-800 mb-3 max-md:text-3xl">
                They trust us already
            </h1>
            <p className="font-medium text-slate-400 mb-10">
                We have received countless positive on Trustpilot. We would be happy to make you also to one of our satisfied customers. <br/>Let's talk and watch out our demo for free.
            </p>
            <div className="relative max-w-3xl m-auto">
                <div className="absolute 
                                z-0
                                w-full
                                max-md:w-[calc(100%_-_(2_*_1.25rem))]
                                2xl:h-[550px]
                                xl:h-[500px]
                                lg:h-[500px]
                                max-sm:bg-transparent
                                h-[500px]
                                ml-5
                                bg-slate-100 
                                rounded-2xl"></div>
                <div className="relative
                                z-1
                                flex
                                flex-col
                                justify-between
                                max-w-3xl 
                                2xl:w-11/12 2xl:h-[550px]
                                xl:w-12/12 xl:h-[500px]
                                lg:w-12/12 lg:h-[500px]
                                max-sm:h-auto
                                h-[500px]
                                w-12/12">
                    { testimonials.map((testimonial, i) => (
                            <div className={"bg-white rounded-xl p-5 shadow-custom-1 mt-5 w-3/4 self-center " + testimonialsCSSPositions[i]} key={"testimonial-" + i}>
                                <h2 className="text-slate-800 text-lg font-semibold text-left mb-3">
                                    "{testimonial.quote}"
                                </h2>
                                <div className="flex flex-row items-center justify-between max-sm:flex-col max-sm:items-start">
                                    <div className="flex flex-row">
                                        <img className="rounded-full w-10 h-10 mr-3" src={testimonial.avatarUrl} alt={testimonial.name}/>
                                        <div>
                                            <p className="text-sm text-left">
                                                <span className="font-medium text-slate-800">
                                                    {testimonial.name + " "}
                                                </span>
                                                <span className="text-slate-500">
                                                    {testimonial.position}
                                                </span>
                                            </p>
                                            <img src={Stars} alt="stars" className="w-20 mt-2"/>
                                        </div>
                                    </div>
                                    <Button text="Read more" color="secondary" size="medium" className="h-fit min-w-fit max-sm:mx-0 max-sm:mt-5 max-sm:self-center max-sm:w-full" onClick={() => onTestimonialClicked(testimonial.link, testimonial.name)}/>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default Testimonials;

interface testimonialObject {
    name: string;
    position: string;
    link: string;
    avatarUrl: string;
    quote: string;
}